import React__default from 'react';
import { useIsMounted__INTERNAL, useStytchB2BClient } from '../b2b/StytchB2BContext.mjs';
import { noProviderError } from '../utils/errors.mjs';
import { invariant } from '../utils/invariant.mjs';
import { AdminPortalSSOContainer } from '../../../adminPortal/sso/AdminPortalSSOContainer.mjs';

/**
 * The Admin Portal SSO UI component.
 * This component must be rendered within a {@link StytchB2BProvider}.
 *
 * See the {@link https://stytch.com/docs/b2b/sdks/javascript-sdk online reference}
 */ const AdminPortalSSO = (props)=>{
    invariant(useIsMounted__INTERNAL(), noProviderError('<AdminPortalMemberManagement />', 'StytchB2BProvider'));
    const stytchClient = useStytchB2BClient();
    return /*#__PURE__*/ React__default.createElement(AdminPortalSSOContainer, {
        client: stytchClient,
        ...props
    });
};

export { AdminPortalSSO };
//# sourceMappingURL=AdminPortalSSO.mjs.map
